import { render } from "./Link.vue?vue&type=template&id=3aa92b14"
import script from "./Link.vue?vue&type=script&lang=js"
export * from "./Link.vue?vue&type=script&lang=js"

import exportComponent from "../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"@apostrophecms/vue-material-design-icons/Link.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3aa92b14"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3aa92b14', __exports__)) {
    api.reload('3aa92b14', __exports__)
  }
  
  module.hot.accept("./Link.vue?vue&type=template&id=3aa92b14", () => {
    api.rerender('3aa92b14', render)
  })

}


export default __exports__